export const SELLER_COUNTRIES = ['IN', 'PK', 'BD', 'PH', 'TH', 'ID', 'SD', 'NG', 'LK', 'KE', 'MA'];

export const ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/809b8c607d8b3eb82ccf1dd7cbe5c8a3-1736260684847/jtbd_card_pjm_icon.png';
